export default __webpack_public_path__ + "8f3df3a76287fe6ff2715e24e39a13c8.svg";